import { useRefs } from "../framework";
import { lenis } from "./lenis";

const clamp = (min, val, max) => Math.max(min, Math.min(max, val));

export default (ref) => {
  if (!ref.announcementBar) return;

  const instances = ref.announcementBar.map((element) => {
    return useRefs({ root: element, namespaced: true, asArray: true });
  });

  let currentIndex = 0;
  let interval = null;

  function fadeToNext() {
    instances.forEach((instance) => {
      const internalIndex = currentIndex % instance.items.length;
      instance.items.forEach((item, idx) => {
        item.style.opacity = internalIndex === idx ? 1 : 0;
      });
      instance.dots.forEach((item, idx) => {
        item.style.opacity = internalIndex === idx ? 1 : 0.3;
      });
    });

    currentIndex++;
  }

  function activateFading() {
    fadeToNext();

    setTimeout(() => {
      instances.forEach((instance) => {
        instance.items.forEach((item) => {
          item.style.transition = "opacity 1s ease";
        });
        instance.dots.forEach((item) => {
          item.style.transition = "opacity 0.5s ease";
        });
      });
    });

    if (!interval) {
      interval = setInterval(fadeToNext, 3000);
    }
  }

  function deactivateFading() {
    instances.forEach((instance) => {
      instance.items.forEach((item) => {
        item.style.removeProperty("opacity");
      });
    });

    clearInterval(interval);
  }

  let announcementBarsHeight = instances.reduce((acc, cur) => {
    const { height } = cur.root.getBoundingClientRect();
    return acc + height;
  }, 0);

  function handleResize() {
    if (window.innerWidth < 769) {
      activateFading();
    } else {
      deactivateFading();
    }
  }

  window.addEventListener("resize", handleResize);

  handleResize();

  function moveHeaderToBelowAnnouncementBar() {
    const value = lenis.animatedScroll * -1 + announcementBarsHeight;
    ref.siteHeader[0].style.transform = `matrix(1, 0, 0, 1, 0, ${clamp(0, value, announcementBarsHeight)})`;
  }

  moveHeaderToBelowAnnouncementBar();

  const teardown = lenis.on("scroll", () => {
    moveHeaderToBelowAnnouncementBar();
  });

  return teardown;
};
